import { Host, forceUpdate, h, } from '@stencil/core';
import { isBrowser, isMobile } from '../../../globals/utils';
import { DEFAULT_LEAVE_DELAY } from './constants';
export class TooltipWrapperComponent {
  onShowModalChange(newValue) {
    if (newValue === false && this.sustainabilityPortal) {
      this.sustainabilityPortal.isOpen = newValue;
    }
  }
  constructor() {
    this.open = () => {
      this.active = true;
      clearTimeout(this.leaveTimer);
      this.didOpen.emit();
    };
    this.close = () => {
      if ((this.isBrowser && !this.isMobile) || (this.isMobile && !this.isSustainabilityPortal)) {
        this.active = false;
        clearTimeout(this.leaveTimer);
        this.didClose.emit();
      }
      if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
        this.sustainabilityPortal.isOpen = false;
      }
    };
    this.handleResizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.handleMouseEnter = () => {
      if (!this.isMobile) {
        this.open();
      }
    };
    this.handleMouseLeave = () => {
      var _a;
      if (!this.isMobile) {
        this.leaveTimer = window.setTimeout(this.close, (_a = this.leaveDelay) !== null && _a !== void 0 ? _a : 0);
      }
    };
    this.handleKeydown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.active ? this.close() : this.open();
      }
    };
    this.handleClick = () => {
      this.open();
      if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
        this.sustainabilityPortal.isOpen = true;
      }
    };
    this.handleDialogClose = this.close;
    this.renderPortalMobileContent = () => {
      if (!this.sustainabilityPortal) {
        this.sustainabilityPortal = document.createElement('pes-sustainability-portal');
        if (!this.sustainabilityPortalTooltipContent) {
          this.sustainabilityPortalTooltipContent = this.sustainabilityPortal.querySelector('[slot="tooltip-content"]')
            || this.host.querySelector('[slot="tooltip-content"]');
        }
        this.sustainabilityPortal.appendChild(this.sustainabilityPortalTooltipContent);
        document.body.append(this.sustainabilityPortal);
      }
    };
    this.renderMobileContent = () => {
      return (h("se-dialog", { size: "small", open: this.active, noBackdrop: true, pageScroll: false }, h("div", { class: "tooltip-wrapper-modal-content" }, h("button", { class: "tooltip-wrapper-modal-close-button", onClick: this.handleDialogClose }), h("slot", { name: "tooltip-content" }))));
    };
    this.renderDesktopContent = (interactiveListeners) => {
      return (h("pes-tooltip", Object.assign({}, interactiveListeners, { ref: (el) => (this.tooltipRef = el), class: "tooltip-wrapper", placement: this.position, arrow: true, active: this.active, reference: this.tooltipContainerRef }), h("div", { class: "tooltip-wrapper-inner-content" }, h("slot", { name: "tooltip-content" }))));
    };
    this.renderContent = (interactiveListeners) => {
      if (this.isBrowser && this.isMobile) {
        if (this.isSustainabilityPortal) {
          return this.renderPortalMobileContent();
        }
        return this.renderMobileContent();
      }
      return this.renderDesktopContent(interactiveListeners);
    };
    this.position = 'bottom';
    this.disableInteractive = false;
    this.leaveDelay = DEFAULT_LEAVE_DELAY;
    this.showTooltip = true;
    this.showModal = false;
    this.isSustainabilityPortal = false;
    this.active = false;
    this.isBrowser = isBrowser();
    this.isMobile = isMobile();
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    forceUpdate(this.host);
    if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
      this.renderPortalMobileContent();
    }
  }
  connectedCallback() {
    window.addEventListener('resize', this.handleResizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }
  render() {
    const interactiveListeners = {};
    if (!this.disableInteractive) {
      interactiveListeners.onMouseEnter = this.handleMouseEnter;
      interactiveListeners.onMouseLeave = this.handleMouseLeave;
    }
    return (h(Host, null, h("div", { ref: (el) => (this.tooltipContainerRef = el), onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onClick: this.handleClick, onKeyDown: this.handleKeydown, onFocusout: this.handleDialogClose, tabIndex: 0, role: "button", class: {
        'tooltip-wrapper-container': true,
        'tooltip-wrapper-container--pointer': this.showTooltip,
      } }, h("slot", { name: "tooltip-activator" })), this.showTooltip && this.renderContent(interactiveListeners)));
  }
  static get is() { return "pes-tooltip-wrapper"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["tooltip-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["tooltip-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "position": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'top' | 'bottom'",
          "resolved": "\"bottom\" | \"top\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "position",
        "reflect": false,
        "defaultValue": "'bottom'"
      },
      "disableInteractive": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-interactive",
        "reflect": false,
        "defaultValue": "false"
      },
      "leaveDelay": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "leave-delay",
        "reflect": false,
        "defaultValue": "DEFAULT_LEAVE_DELAY"
      },
      "showTooltip": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-tooltip",
        "reflect": false,
        "defaultValue": "true"
      },
      "showModal": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-modal",
        "reflect": false,
        "defaultValue": "false"
      },
      "isSustainabilityPortal": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-sustainability-portal",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "active": {},
      "isBrowser": {},
      "isMobile": {}
    };
  }
  static get events() {
    return [{
        "method": "didOpen",
        "name": "didOpen",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "didClose",
        "name": "didClose",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "host"; }
  static get watchers() {
    return [{
        "propName": "showModal",
        "methodName": "onShowModalChange"
      }];
  }
}
